<template>
	<div class="item">
		<sui-modal v-model="openRechazar" :size="'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Rechazar archivo</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="closeRechazar"
				></i>
			</sui-modal-header>
			<sui-modal-content style="max-height: 85vh; overflow: scroll;">
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<div class="ui form">
										<div class="field">
											<label>Observación</label>
											<textarea v-model="observacion" rows="2"></textarea>
										</div>
									</div>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="rechazarArchivo"
					>Rechazar</BaseButton
				>
				<BaseButton
					v-show="name === 'certificadoBachillerato'"
					style-button="warning"
					style="margin: 10px"
					style-class="right floated"
					@click.native="rechazarArchivoConSolicitud"
					>Rechazar y solicitar Constancia Aclaratoria</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="toggleRechazar"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>
		<sui-modal v-model="open" :size="esPdf ? 'large' : 'small'">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont">Visor de documentos</strong>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="close"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-header>
						<sui-grid>
							<sui-grid-row>
								<sui-grid-column :width="16">
									<img
										v-show="!esPdf"
										class="ui fluid image"
										:src="urlArchivo"
									/>
									<object
										v-show="esPdf"
										:data="`${urlArchivo}`"
										type="application/pdf"
										width="100%"
										height="700px"
									>
										<embed :data="`${urlArchivo}`" type="application/pdf" />
									</object>
								</sui-grid-column>
							</sui-grid-row>
						</sui-grid>
					</sui-header>
				</sui-modal-description>
			</sui-modal-content>
			<sui-modal-actions style="padding: 0 !important;">
				<BaseButton
					style-button="primary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="aceptarArchivo"
					>Aprobar</BaseButton
				>
				<BaseButton
					style-button="secondary"
					style="margin: 10px"
					style-class="right floated"
					@click.native="toggle"
					>Cerrar</BaseButton
				>
			</sui-modal-actions>
		</sui-modal>
		<div
			class="right floated content"
			style="padding: 0; padding-right: .5em; padding-left: .5em"
		>
			<a
				v-show="urlArchivo"
				href="#"
				class="ui button mini icon secondary"
				title="Mirar archivo"
				@click="visualizarArchivo"
			>
				<i class="icon eye"></i>
			</a>
			<a
				v-show="urlArchivo"
				:href="urlArchivo"
				class="ui button mini icon primary"
				target="_blank"
				title="Descargar archivo"
			>
				<i class="icon download"></i>
			</a>
			<a v-show="!urlArchivo" class="ui button mini yellow">
				Sin archivo asignado
			</a>
			<a
				v-show="(urlArchivo && isPending) || (!isPending && !isValid)"
				href="#"
				class="ui button mini icon green"
				title="Aprobar archivo"
				@click="aceptarArchivo"
			>
				<i class="icon check"></i>
			</a>
			<a
				v-show="(urlArchivo && isPending) || (!isPending && isValid)"
				href="#"
				class="ui button mini icon red"
				title="Rechazar archivo"
				@click="rechazarArchivoOpen"
			>
				<i class="icon close"></i>
			</a>
			<div class="ui action input icon">
				<button
					title="Subir archivo"
					class="ui icon button mini"
					@click="onClickInputFile"
				>
					<i class="attach icon"></i>
				</button>
				<input
					:ref="`file-${name}`"
					type="file"
					accept="application/pdf,.pdf"
					:name="`file-${name}`"
					@change="onChangeFile"
				/>
			</div>
		</div>
		<div
			class="content"
			style="padding: 0; padding-right: .5em; padding-left: .5em"
		>
			<div class="header">
				<i
					v-show="isValid"
					title="Valido"
					class="green check icon"
					style=" right: 3em;"
				></i>
				<i
					v-show="isPending"
					title="Pendiente"
					class="yellow info circle icon"
					style=" right: 3em;"
				></i>
				<i
					v-show="hasError"
					title="Erroneo"
					class="red close icon"
					style=" right: 3em;"
				></i>
				{{ titulo }}
			</div>
			<p v-show="mensaje"> <b>Observación:</b> {{ mensaje }} </p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		documentoTramiteId: {
			type: Number,
			default: null
		},
		titulo: {
			type: String,
			default: null
		},
		name: {
			type: String,
			default: null
		},
		nombreArchivo: {
			type: String,
			default: null
		},
		urlArchivo: {
			type: String,
			default: null
		},
		mensaje: {
			type: String,
			default: ''
		},
		isValid: {
			type: Boolean,
			default: false
		},
		isPending: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			open: false,
			observacion: '',
			openRechazar: false
		};
	},
	computed: {
		esPdf: function() {
			if (!this.urlArchivo) return false;
			const splitFile = this.urlArchivo.split('.');
			return splitFile[splitFile.length - 1].toLowerCase() === 'pdf';
		}
	},
	methods: {
		visualizarArchivo($event, archivo) {
			this.open = true;
		},
		toggle() {
			this.open = !this.open;
		},
		close() {
			this.open = false;
		},
		toggleRechazar() {
			this.openRechazar = !this.openRechazar;
		},
		closeRechazar() {
			this.openRechazar = false;
		},
		rechazarArchivoOpen() {
			this.observacion = '';
			this.openRechazar = true;
		},
		rechazarArchivo() {
			this.openRechazar = false;
			this.$emit('rechazar', {
				name: this.name,
				observacion: this.observacion,
				id: this.documentoTramiteId,
				verificado: true,
				valido: false
			});
		},
		rechazarArchivoConSolicitud() {
			this.openRechazar = false;
			this.$emit('rechazarConSolicitud', {
				name: this.name,
				observacion: this.observacion,
				id: this.documentoTramiteId,
				verificado: true,
				valido: false
			});
		},
		aceptarArchivo() {
			this.open = false;
			this.openRechazar = false;
			this.$emit('aprobar', {
				name: this.name,
				observacion: '',
				id: this.documentoTramiteId,
				verificado: true,
				valido: true
			});
		},
		onClickInputFile($event) {
			this.$refs[`file-${this.name}`].click();
		},
		onChangeFile($event) {
			this.$emit('subir', {
				name: this.name,
				value: $event.target.files[0]
			});
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
